import { render, staticRenderFns } from "./personInforAttend.vue?vue&type=template&id=36cd6a08&scoped=true&"
import script from "./personInforAttend.vue?vue&type=script&lang=js&"
export * from "./personInforAttend.vue?vue&type=script&lang=js&"
import style0 from "./personInforAttend.vue?vue&type=style&index=0&id=36cd6a08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd6a08",
  null
  
)

export default component.exports